export const KEYS = {
  email: "email",
};

export function getSessionStorageOrDefault(
  key: string,
  defaultValue: string | undefined,
) {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }

  return typeof stored === "string" ? stored : undefined;
}

export function saveSessionStorage(key: string, value: string | undefined) {
  if (value === undefined) {
    sessionStorage.removeItem(key);
    return;
  }
  sessionStorage.setItem(key, value);
}

export function getLocalStorageOrDefault<
  DefaultType extends string | undefined,
>(key: string, defaultValue: DefaultType): string | DefaultType {
  const stored = localStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }

  return typeof stored === "string" ? stored : defaultValue;
}

export function saveLocalStorage(key: string, value: string | undefined) {
  if (value === undefined) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, value);
}
